import { markProductTemplateAsStock } from 'api/operations/productServiceV2';
import { makeAutoObservable } from 'mobx';
import { RootStore } from 'store/rootStore';

interface ShortTemplateInfo {
  id: string;
  name: string;
}

export default class MarkAsStockModalStore {
  rootStore: RootStore;
  showMarkAsStockModal = false;
  shortTemplateInfo: ShortTemplateInfo = { id: '', name: '' };

  private setShortTemplateInfo(templateInfo: ShortTemplateInfo): void {
    this.shortTemplateInfo = templateInfo;
  }

  private setMarkAsStockModal(status: boolean): void {
    this.showMarkAsStockModal = status;
  }

  public openMarkAsStockModal(name: string, templateId: string): void {
    this.setShortTemplateInfo({ id: templateId, name });
    this.setMarkAsStockModal(true);
  }

  public closeMarkAsStockModal(): void {
    this.setMarkAsStockModal(false);
  }

  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
  public async onMarkAsStock(): Promise<void> {
    if (this.shortTemplateInfo?.id) {
      await markProductTemplateAsStock(this.shortTemplateInfo.id);
    }
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
